/* @ngInject */
function groupService (ConnectorWebService, CONSTANTS, Utils) {
  var oGroupService = {}

  oGroupService.getGroups = function getGroups (iTop, iSkip, params, bSimplified, isAnalytics, groupsIds) {
    var sUrl = bSimplified ? CONSTANTS.URL_GROUPS_SIMPLIFIED : CONSTANTS.URL_GROUPS

    if (params?.searchTerm) {
      sUrl = Utils.fnAddQueryToUrl(sUrl, {
        search: params.searchTerm
      })
    }

    if (params?.$sort && params?.$order) {
      sUrl = Utils.fnAddQueryToUrl(sUrl, {
        $sort: params.$sort
      })

      sUrl = Utils.fnAddQueryToUrl(sUrl, {
        $order: params.$order
      })
    }

    if (iTop || iSkip) {
      sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
    }

    if (isAnalytics) {
      sUrl = Utils.fnAddQueryToUrl(sUrl, { isAnalytics })
    }

    if (groupsIds?.length) {
      groupsIds.forEach(groupId => {
        sUrl = Utils.fnAddQueryToUrl(sUrl, { groupsIds: groupId })
      })
    }

    return ConnectorWebService.get(sUrl)
  }

  oGroupService.getGroupById = function (iGroupId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_GROUPS_ID, [iGroupId])

    return ConnectorWebService.get(sUrl)
  }

  oGroupService.deleteGroup = function (iGroupId) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_GROUPS_ID, [iGroupId])

    return ConnectorWebService.fnDelete(sUrl)
  }

  oGroupService.createGroup = function (oData) {
    var sUrl = CONSTANTS.URL_GROUPS

    return ConnectorWebService.post(sUrl, oData)
  }

  oGroupService.updateGroup = function (iGroupId, oData) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_GROUPS_ID, [iGroupId])

    return ConnectorWebService.put(sUrl, oData)
  }

  oGroupService.countLinkedMaterial = function (groupId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_GROUPS_ID_LINKED_MATERIAL, [groupId])

    return ConnectorWebService.get(url)
  }

  oGroupService.getAllGroups = function () {
    const top = 100
    let index = 0
    const groups = []
    let groupCount = null

    function recursiveGetGroups () {
      return oGroupService.getGroups(top, top * index).then(response => {
        groups.push(...response.d.results)
        groupCount = response.d.__count

        if (groups.length < groupCount) {
          index++
          return recursiveGetGroups(index)
        } else {
          return groups
        }
      })
    }

    return recursiveGetGroups()
  }

  return oGroupService
}

export { groupService }
